import { actions as labelActions } from 'actions/labels';
import { actions as metersActions } from 'actions/meters';

const meters = (state = {}, action) => {
  const { type, payload } = action;

  switch (type) {
    case labelActions.initLabels:
      return payload.meters;
    case metersActions.resetValue:
    case metersActions.setActive:
      return {
        ...state,
        [payload.screen]: {
          ...state[payload.screen],
          data: state[payload.screen].data.map((item, i) => {
            const newItem = payload.items[i];

            if (newItem.label === item.label) {
              return newItem;
            }

            return item;
          })
        }
      };
    default:
      return state;
  }
};

export default meters;



// WEBPACK FOOTER //
// ./src/reducers/meters.js